// extracted by mini-css-extract-plugin
module.exports = {"DeliveryInformations":"styles_DeliveryInformations__0zCfc","icon":"styles_icon__9_Qqw","text":"styles_text__COSaS","isLoading":"styles_isLoading__86_wg"};